import React from 'react';
import { TypographyH2 } from '@/Components/shadcn/typography';
import UIStrings from '@/Utils/UIStrings';

const JobAdStepHeader = (): React.JSX.Element => {
    return (
        <div className="flex flex-col items-center justify-center gap-2 py-2.5">
            <TypographyH2 className="text-foreground">{UIStrings.CreateJobDescription}</TypographyH2>
        </div>
    );
};

export default JobAdStepHeader;
